
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <b>Henri-Paul Cornu, 71 ans, décédé le 26 mars 2020</b>
    <br />
    <br />
    <i>Sa fille Céline Fleury-Cornu raconte:</i>
    <br />
    <p>
  «Le 25 mars, mon père, Henri-Paul, était gravement malade du Covid-19. Il
  était aux soins intensifs de l'Hôpital cantonal de Fribourg. Je lui ai dit au
  revoir une dernière fois, au téléphone. Je vivais alors à Zurich avec mon mari
  et mes trois enfants. Nous savions qu'il allait mourir. Mais un voyage à
  travers la Suisse semblait à l'époque bien trop risqué.
    </p>
    <p>
  D'une part, j’avais peur d'être infectée moi aussi, d'autre part, j'avais peur
  de la confrontation et des images qu’elle pourrait me laisser: mon père aux
  soins intensifs, les malades et le personnel soignant autour de lui, les
  machines, le rythme effréné des soins. Nous avons donc choisi de lui parler
  par téléphone. Nous étions assis, tous les cinq, devant l’appareil. C'est
  surtout moi qui ai parlé. J'ai dit à mon père qu’il ne devait pas s'inquiéter,
  qu’il pouvait lâcher prise et partir en paix, que nous l’aimions. Notre plus
  jeune fille s’est aussi exprimée. Mes deux autres enfants et mon mari, Pascal,
  n’ont rien pu dire. Ils pleuraient. C'était tout simplement horrible, pour
  nous tous, incroyablement triste. Mon père, lui, ne parvenait pas à parler et
  nous comprenait difficilement à cause de ses problèmes respiratoires. Je l'ai
  entendu dire: “C'est dur". Il a également déclaré que ses funérailles seraient
  probablement comme en Italie: rapides, sans cérémonie et sans visiteurs. Il
  avait déjà lu les journaux et vu les reportages télévisés qui parlaient de la
  pandémie en Italie Je lui ai dit qu'il n'avait pas à s'inquiéter pour cela.
  Nous nous en occuperons. Après quelques minutes de conversation téléphonique,
  nous avons raccroché. Mon père est décédé juste après, dans la nuit. Le
  lendemain, c'était l'anniversaire de ma mère, Anne-Lise, qui a eu 69 ans. Ils
  ont été mariés pendant cinquante ans.»
    </p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;